import React from 'react';
import classnames from 'classnames';
import Text from 'src/components/Text';
import styles from './styles.module.scss';
import logo from './logo.svg';
import genbankLogo from './genbankLogo.jpg';

type Props = {
  className?: string;
}

const SBPLogoGenbank: React.FC<Props> = ({ className}) => {
  const containerClassnames = classnames(styles['container'], className);
  
  return (
    <div className={containerClassnames}>
      <div className={styles['logo']}>
        <img src={genbankLogo} alt="" className={styles['img']} />
        <div className={styles['logo-devider']}/>
        <img src={logo} alt="" className={styles['img']} />
      </div>
      <div className={styles['text-block']}>
        <Text type="logo">Агент 1С:СБП</Text>
        <Text type="span">ГЕНБАНК</Text>
      </div>
    </div>
  );
};

export default SBPLogoGenbank;
